"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TabHeader = _interopRequireDefault(require("./TabHeader.style"));
var _StyledPillContainer = _interopRequireDefault(require("./StyledPillContainer.style"));
var _StyledSplashContainer = _interopRequireDefault(require("./StyledSplashContainer.style"));
var _StyledClassicContainer = _interopRequireDefault(require("./StyledClassicContainer.style"));
var _constants = require("../constants");
var _STYLED_MAP;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var STYLED_MAP = (_STYLED_MAP = {}, _defineProperty(_STYLED_MAP, _constants.VIEW_TYPE["default"], _TabHeader["default"]), _defineProperty(_STYLED_MAP, _constants.VIEW_TYPE.pill, _StyledPillContainer["default"]), _defineProperty(_STYLED_MAP, _constants.VIEW_TYPE.splash, _StyledSplashContainer["default"]), _defineProperty(_STYLED_MAP, _constants.VIEW_TYPE.classic, _StyledClassicContainer["default"]), _STYLED_MAP);
var TabHeader = function TabHeader(_ref) {
  var view = _ref.view,
    alignment = _ref.alignment,
    noMargins = _ref.noMargins,
    children = _ref.children,
    isWizzard = _ref.isWizzard,
    controllable = _ref.controllable;
  var StyledComponent = STYLED_MAP[view] || _TabHeader["default"];
  return /*#__PURE__*/_react["default"].createElement(StyledComponent, {
    alignment: alignment,
    noMargins: noMargins,
    view: view,
    isWizzard: isWizzard,
    controllable: controllable,
    className: "tab-headers headers-".concat(view)
  }, children);
};
TabHeader.defaultProps = {
  noMargins: false,
  isWizzard: false,
  controllable: false
};
TabHeader.propTypes = {
  isWizzard: _propTypes["default"].bool,
  controllable: _propTypes["default"].bool,
  view: _propTypes["default"].string.isRequired,
  alignment: _propTypes["default"].string.isRequired,
  noMargins: _propTypes["default"].bool,
  children: _propTypes["default"].node.isRequired
};
TabHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TabHeader",
  "props": {
    "noMargins": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "isWizzard": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "controllable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "view": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "alignment": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "children": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": true
    }
  }
};
var _default = TabHeader;
exports["default"] = _default;